import globalAxios from "../GlobalAxios";

const googleLogin = async () => {
  const res = await globalAxios.get("/api/auth/google");
  window.location.href = res.data.auth_url;
};

const callBack = async (code) => {
  const res = await globalAxios.get("/api/auth/callback", {params: {code}});
  return res.data;
};

// const uploadYouTube = async () => {
//   const res = await globalAxios.post("/api/youtube/upload");
//   return res.data;
// };

const uploadYouTube = async (params) => {
  try {
    // const token = sessionStorage.getItem("google_access_token");
    // const config = {
    //   headers: {
    //     Authorization: `Bearer ${token}`
    //   }
    // };
    // const res = await globalAxios.post("/api/youtube/upload", null, config);
    const res = await globalAxios.post("/api/youtube/upload", {params})
    return res.data;
  } catch (error) {
    console.error("Error:", error);
    throw error; 
  }
};

const fetchPlatforms = async () => {
  const res = await globalAxios.get("/api/social/platforms");
  return res.data?.data || [];
};

const cancelPublishTask = async (id) => {
  if (!id) return null;
  const res = await globalAxios.post(`/api/social/publish/tasks/${id}/cancel`);
  return res.data?.data || null;
};

const fetchYoutubeCategories = async (params = {}) => {
  const res = await globalAxios.get("/api/social/youtube/categories", { params });
  return res.data?.data || [];
};

const fetchIntegrations = async (params = {}) => {
  const res = await globalAxios.get("/api/social/integrations", { params });
  return res.data?.data || [];
};

const createPublishTasks = async (payload) => {
  const res = await globalAxios.post("/api/social/publish/tasks", payload);
  return res.data?.data || [];
};

const fetchPublishTasks = async (params = {}) => {
  const res = await globalAxios.get("/api/social/publish/tasks", { params });
  return res.data?.data || [];
};

const hidePublishTask = async (id) => {
  const res = await globalAxios.patch(`/api/social/publish/tasks/${id}/hide`);
  return res.data?.data || null;
};

const hideAllPublishTasks = async () => {
  const res = await globalAxios.patch('/api/social/publish/tasks/hide-all');
  return res.data?.data || null;
};

const fetchLocations = async (params = {}) => {
  const res = await globalAxios.get("/api/social/locations", { params });
  return res.data?.data || res.data?.list || [];
};

const fetchTaggableUsers = async (params = {}) => {
  const res = await globalAxios.get("/api/social/taggable-users", { params });
  return res.data?.data || res.data?.list || [];
};

const fetchLiveSessions = async () => {
  const res = await globalAxios.get("/api/social/live-sessions");
  return res.data?.data || [];
};

const createLiveSession = async (payload) => {
  const res = await globalAxios.post("/api/social/live-sessions", payload);
  return res.data?.data || null;
};

const startLiveSession = async (id) => {
  const res = await globalAxios.post(`/api/social/live-sessions/${id}/start`);
  return res.data?.data || null;
};

const completeLiveSession = async (id) => {
  const res = await globalAxios.post(`/api/social/live-sessions/${id}/complete`);
  return res.data?.data || null;
};

const failLiveSession = async (id, payload = {}) => {
  const res = await globalAxios.post(`/api/social/live-sessions/${id}/fail`, payload);
  return res.data?.data || null;
};

const updateLiveSessionSettings = async (id, payload) => {
  const res = await globalAxios.patch(`/api/social/live-sessions/${id}/settings`, payload);
  return res.data?.data || null;
};

const fetchSessionStream = async (sessionId, integrationId) => {
  const res = await globalAxios.get(`/api/social/live-sessions/${sessionId}/integrations/${integrationId}/streams`);
  return res.data?.data || null;
};

const saveSessionStream = async (sessionId, integrationId, payload) => {
  const res = await globalAxios.patch(`/api/social/live-sessions/${sessionId}/integrations/${integrationId}/streams`, payload);
  return res.data?.data || null;
};

const startLiveRelay = async (payload) => {
  const res = await globalAxios.post('/api/social/live-relay/start', payload);
  return res.data?.data || null;
};

const stopLiveRelay = async (payload) => {
  const res = await globalAxios.post('/api/social/live-relay/stop', payload);
  return res.data?.data || null;
};

const beginOAuth = async (platformKey) => {
  const res = await globalAxios.post(`/api/social/oauth/${platformKey}/begin`);
  return res.data?.data;
};

const createIntegration = async (payload) => {
  const res = await globalAxios.post("/api/social/integrations", payload);
  return res.data?.data;
};

const updateIntegration = async (id, payload) => {
  const res = await globalAxios.put(`/api/social/integrations/${id}`, payload);
  return res.data?.data;
};

const deleteIntegration = async (id) => {
  const res = await globalAxios.delete(`/api/social/integrations/${id}`);
  return res.data;
};

export default {
  googleLogin,
  callBack,
  uploadYouTube,
  fetchPlatforms,
  fetchIntegrations,
  fetchYoutubeCategories,
  cancelPublishTask,
  createPublishTasks,
  fetchPublishTasks,
  hidePublishTask,
  hideAllPublishTasks,
  fetchLocations,
  fetchTaggableUsers,
  fetchLiveSessions,
  createLiveSession,
  startLiveSession,
  completeLiveSession,
  failLiveSession,
  updateLiveSessionSettings,
  fetchSessionStream,
  saveSessionStream,
  startLiveRelay,
  stopLiveRelay,
  beginOAuth,
  createIntegration,
  updateIntegration,
  deleteIntegration,
};
